import s from './Itinerary.module.scss';
import Title from '../Title/Title';
import { CLOUDINARY_BASE_URL } from '../config/cloudinary';


const img = (path) => `${CLOUDINARY_BASE_URL}${path}`;

const schedules = [
  {
    time: '07:30',
    title: 'ホテルお迎え',
    text: 'ご宿泊先のホテルへお迎えに上がります。',
    image: img('v1741535472/reef_nx1a4a.webp'),
  },
  {
    time: '08:00',
    title: '港を出発',
    text: '快適なクルーズで目的地へ向かいます。',
    image: img('v1741535472/reef_nx1a4a.webp'),
  },
  {
    time: '10:00',
    title: 'リーフ到着・シュノーケリング',
    text: '透明度抜群の海でシュノーケリングをお楽しみください。',
    image: img('v1741535472/reef_nx1a4a.webp'),
  },
  {
    time: '12:30',
    title: 'ランチ',
    text: '宮古島の景色を眺めながらランチタイム。',
    image: img('v1741535472/reef_nx1a4a.webp'),
  },
  {
    time: '14:30',
    title: 'リーフ出発',
    text: '午後もゆっくり海を楽しみながら帰路へ。',
    image: img('v1741535472/reef_nx1a4a.webp'),
  },
  {
    time: '16:00',
    title: 'ホテルお送り',
    text: 'ホテルまでお送りします。お疲れさまでした！',
    image: img('v1741535472/reef_nx1a4a.webp'),
  },
];

const getScheduleImage = (item) => {
  if (item.image) return item.image;
  if (Array.isArray(item.img) && item.img.length > 0) return item.img[0];
  return img('v1741535472/reef_nx1a4a.webp');
};

const Itinerary = ({ scheduleItems = [], showImages = true }) => {
  const items = scheduleItems.length > 0 ? scheduleItems : schedules;

  return (
    <section className={s.root}>
      <Title kicker="Sample" title="Schedule" />
      <div className={s.timeline}>
        {items.map((item, index) => (
          <article className={s.item} key={`${item.time}-${index}`}>
            <div className={s.dot}></div>

            <div className={`${s.body} ${showImages ? "" : s.noImage}`}>
              <div className={`${s.textArea} ${item.time ? "" : s.noTime}`}>
                {item.time && <span className={s.time}>{item.time}</span>}

                <div>
                  <h3>{item.title || item.description}</h3>
                  {(item.text || (item.title && item.description)) && (
                    <p>{item.text || item.description}</p>
                  )}
                </div>
              </div>

              {showImages && (
                <div className={s.image}>
                  <img
                    src={getScheduleImage(item)}
                    alt={item.title || item.description}
                  />
                </div>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Itinerary;
